<template>
  <div class="referral-program-page">
    <van-nav-bar
      safe-area-inset-top
      placeholder
      fixed
      left-arrow
      z-index="1003"
      class="nav-bar"
      :title="$t(`${i18nPrefix}.myProgram`)"
      @click-left="onLeftIconClick"
    >
    </van-nav-bar>
    <div class="content">
      <div v-if="rootCompanyId === 6429" class="hsbc-tip">
        {{ $t(`${i18nPrefix}.HSBCCustomInfo`) }}
      </div>
      <div class="title">
        {{ $t(`${i18nPrefix}.referralProgramTitle`) }}
        <span class="common_style">{{ $t(`${i18nPrefix}.referralProgramPowered`) }}</span>
      </div>
      <div v-if="rootCompanyId === 6429" v-html="$t(`${i18nPrefix}.HSBCReferralProgramIntro}`)" class="label">
      </div>
      <div v-else class="label">
        {{ $t(`${i18nPrefix}.referralProgramIntro`) }}
      </div>
      <div class="title">
        {{ $t(`${i18nPrefix}.earningRewardsTitle`) }}
      </div>
      <div class="label">
        {{ $t(`${i18nPrefix}.earningRewardsIntro`) }}
      </div>
      <div class="title">
        {{ $t(`${i18nPrefix}.howTo_referTitle`) }}
      </div>
      <div class="label">
        {{ $t(`${i18nPrefix}.howTo_referIntro`) }}
      </div>
      <div class="title">
        {{ $t(`${i18nPrefix}.myEarningRewardTitle`) }}
      </div>
      <div class="label">
        {{ $t(`${i18nPrefix}.myEarningRewardIntro`) }}
      </div>
      <div class="title">
        {{ $t(`${i18nPrefix}.aboutTaxTitle`) }}
      </div>
      <div class="label">
        {{ $t(`${i18nPrefix}.aboutTaxIntro`) }}
      </div>
      <div class="title">
        {{ $t(`${i18nPrefix}.contactUsTitle`) }}
      </div>
      <div v-html="$t(`${i18nPrefix}.contactUsIntro`)" class="label">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    personalInfo: {
      type: Object
    }
  },
  data () {
    return {
      i18nPrefix: 'personal.referrals.program'
    }
  },
  computed: {
    rootCompanyId () {
      return this.personalInfo.employee?.company.root_company.id
    },
    companyId () {
      return this.$route.query.company_id
    },
    back () {
      return this.$route.query.back
    }
  },
  methods: {
    onLeftIconClick () {
      if (this.back) {
        this.$router.push(this.back)
      } else {
        this.$router.push({ path: '/recruiting/personal/home', query: { company_id: this.companyId } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.referral-program-page {
  .nav-bar {
    ::v-deep {
      .van-nav-bar__content {
        height: 50px;
        border-bottom: 1px solid #DCDFE6;

        .van-nav-bar__title {
          font-weight: 400;
          font-size: 18px;
          color: #303133;
        }

        .van-nav-bar__left {
          padding-left: 8px;

          .van-icon {
            font-size: 18px;
            color: #000;
          }
        }

        .van-nav-bar__right {
          padding-right: 12px;
        }
      }
    }
  }

  .content {
    padding: 20px;
    line-height: 20px;
    background-color: #fff;

    .hsbc-tip {
      font-weight: bold;
      color: red;
    }

    .title {
      font-weight: bold;
      font-size: 18px;
      line-height: 24px;
      color: #0096cc;
      padding-top: 20px;

      .common_style {
        font-weight: normal;
        font-size: 14px;
        color: #232323;
      }
    }

    .label {
      padding-top: 10px;
    }
  }

}
</style>
